// ── 홈 화면(HomePage) 색상 전용 — 여기 값만 바꾸면 전체 화면에 반영됨 ──────
// 카드별로 묶어뒀고, 여러 카드에서 같이 쓰는 색은 common에 모아둠.

export const theme = {
  common: {
    white: '#fff',
    pageBg: '#f0f2f5',
    borderLight: '#e5e7eb',
    grayLight: '#d1d5db',
    grayMid: '#9ca3af',
    grayDark: '#6b7280',
    textDark: '#111827',
    textBody: '#374151',
    brand: '#4f46e5',       // 프로필 원, 링크 버튼
    success: '#22c55e',
    successDark: '#16a34a',
    danger: '#ef4444',
    dangerDark: '#dc2626',
    info: '#3b82f6',
  },

  // 상단 헤더 + 프로필 드롭다운
  header: {
    bg: '#fff',
    title: '#111827',
    subtitle: '#9ca3af',
    profileBg: '#4f46e5',
    profileText: '#fff',
    dropdownBg: '#fff',
    dropdownDivider: '#f3f4f6',
    linkText: '#4f46e5',
    logoutText: '#ef4444',
  },

  // 상단 아이콘 4개 카드 (고지서/사용량/출입관리/서류관리)
  topIconCard: {
    bg: '#fff',
    border: '#e5e7eb',
    shadowBase: '#d1d5db',
    label: '#111827',
    sub: '#9ca3af',
  },

  // 전기사용량 카드 (다크브라운 테마)
  electricity: {
    bg: '#2A2420',
    shadow: 'rgba(42,36,32,0.35)',
    title: '#fff',
    toggleArrow: '#C4B5A0',
    legendText: '#D6C7B0',
    noDataText: '#A89880',
    gridLine: '#3D342C',
    tapLine: '#9ca3af',
    axisPrimary: '#93c5fd',   // 왼쪽(101) y축 숫자
    axisSecondary: '#6ee7b7', // 오른쪽(102/공용) y축 숫자
    dateLabel: '#D6C7B0',
    dateLabelSunday: '#E8A090',
    hourLabel: '#A89880',
    tooltipBg: '#fff',
    tooltipTitle: '#1e3a6e',
    tooltipText: '#374151',
    // 시리즈 색상 (101/102/공용)
    series101: '#60A5FA',
    series102: '#FBBF24',
    seriesCommon: '#34D399',
    // 월 선택 드롭다운
    selectBg: '#F5E6C8',
    selectBorder: '#E8D9C0',
    selectText: '#5C4A32',
    // 요금 상세(펼쳤을 때) — amber 계열
    billingRowBg: '#fef3c7',
    billingRowLabel: '#92400e',
    billingRowValue: '#b45309',
    billingRowFee: '#78350f',
    billingDetailBg: '#fffbeb',
    billingDetailBorder: '#fde68a',
    billingDetailText: '#78350f',
    billingDetailSubtext: '#92400e',
    billingEmptyText: '#94a3b8',
    billingLoadingText: '#A89880',
  },

  // 계약만기 관리 카드
  contract: {
    bg: '#004D1A',
    shadow: 'rgba(30,58,110,0.3)',
    title: '#fff',
    loadingText: 'rgba(255,255,255,0.4)',
  },

  // 보안점검 카드 (골드 테마)
  security: {
    bg: '#998000',
    title: '#fff',
    itemBg: '#78350F',
    itemBorder: '#A16207',
    itemShadow: 'rgba(0,0,0,0.35)',
    itemShadowSoft: 'rgba(0,0,0,0.25)',
    label: '#fff',
    doorIconFill: '#FDE68A',
    doorIconStroke: '#FCD34D',
    doorIconDot: '#64748B',
    toggleOff: '#A8A29E',
    toggleOn: '#3b82f6',
    toggleThumb: '#fff',
    neutralDot: '#D6D3D1',
    timeText: '#fff',
  },

  // 보일러실 누수확인 카드 (네이비 테마)
  leak: {
    bg: '#1e3a6e',
    title: '#fff',
    itemBgNormal: '#0B3B3B',
    itemBgAlert: '#DC2626',
    label: '#fff',
    dotNormal: '#22c55e',
    dotAlert: '#f87171',
    dotGlowAlert: 'rgba(248,113,113,0.6)',
    dotGlowNormal: 'rgba(45,212,191,0.4)',
    statusTextNormal: '#fff',
    statusTextAlert: '#fca5a5',
    loadingText: '#8FA6A6',
  },

  // 보안/누수 이벤트 툴팁(말풍선) — 공용
  eventBalloon: {
    bg: '#fff',
    loadingText: '#9ca3af',
    errorText: '#ef4444',
    emptyText: '#9ca3af',
    rowText: '#374151',
    dotPositive: '#22c55e',
    dotNegative: '#ef4444',
    labelPositive: '#16a34a',
    labelNegative: '#dc2626',
  },

  // 하단 액션 버튼 4개 (등록/명세서조정/텔레그램/알림톡)
  actionButtons: {
    disabledBg: '#9ca3af',
    labelDefault: '#fff',
    register: '#1e3a6e',
    editBill: '#1e3a6e',
    telegram: '#2AABEE',
    kakao: '#FEE500',
    kakaoLabel: '#3B1D17',
  },

  // 당겨서 새로고침 스피너 + 페이지 배경
  pullRefresh: {
    pageBg: '#f0f2f5',
    ringBase: '#d1d5db',
    ringActive: '#3b82f6',
    ringInactive: '#9ca3af',
  },

  // 비밀번호 변경 결과 메시지
  pwMessage: {
    success: '#16a34a',
    fail: '#dc2626',
  },
};

export default theme;
